import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface LostItemSignatureModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: (receiver: string) => void;
}

const LostItemSignatureModal = ({
  open,
  onOpenChange,
  onConfirm,
}: LostItemSignatureModalProps) => {
  const [receiver, setReceiver] = useState("");

  const handleConfirm = () => {
    if (!receiver.trim()) {
      // Minimal validation
      return;
    }
    onConfirm(receiver);
    setReceiver("");
  };

  const handleModalClose = () => {
    setReceiver("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={handleModalClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Delivery Confirmation</DialogTitle>
        </DialogHeader>
        <div className="mt-2 space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">
              Name of receiver
            </label>
            <input
              type="text"
              value={receiver}
              onChange={e => setReceiver(e.target.value)}
              className="w-full border rounded px-2 py-1 text-black dark:text-white"
              placeholder="Guest full name"
            />
          </div>
        </div>
        <DialogFooter className="flex justify-between">
          <Button
            variant="outline"
            onClick={handleModalClose}
            type="button"
          >
            Cancel
          </Button>
          <Button onClick={handleConfirm}>
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default LostItemSignatureModal;
